
































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog, Notify } from 'vant';
import moment from 'moment';
import { lowerFirst } from 'lodash';
@Component
export default class LearningRecordForm extends Vue {
  form: any = {
    Id: '',
    ClassName: '',
    EndDate: '',
    StartDate: '',
    Days: 0,
    Address: '',
  };
  isDisabled: boolean = false;
  showStartTimePicker: boolean = false;
  showEndTimePicker: boolean = false;
  isThroughState: string = ''; // 审核状态判断

  get TrainRecordType() {
    return models.TrainRecordType;
  }

  mounted() {
    if (this.$route.query.detailData) {
      const detail = JSON.parse(this.$route.query.detailData as any);
      Object.keys(this.form).forEach(k => {
        const key = lowerFirst(k);
        if (key in detail) this.form[k] = detail[key];
      });
      this.form.StartDate = moment(this.form.StartDate).format('YYYY-MM-DD');
      this.form.EndDate = moment(this.form.EndDate).format('YYYY-MM-DD');
      this.isThroughState = this.$route.query.isThroughState as string;
      this.isDisabled = true;
    }
  }

  editData() {
    this.isDisabled = false;
  }

  async onDel() {
    Dialog.confirm({
      message: '确定删除吗？',
    }).then(async () => {
      try {
        const { data } = await api.TrainRecords.deletes_POST({
          ids: [this.form.Id],
        });
        Notify({ type: 'success', message: '删除成功' });
        this.$router.go(-1);
      } catch (error) {
        Notify({ type: 'danger', message: error });
      }
    });
  }

  async onSubmit() {
    try {
      const { data, success, message } = await api.TrainRecords.mobileSave_POST({ ...this.form, Type: 2 });
      if (success) {
        //申报成功，清空form
        for (let k of Object.keys(this.form)) {
          Vue.delete(this.form, k);
        }
        Dialog.alert({
          message: '添加成功，请耐心等待审核',
        }).then(() => {
          this.$router.go(-1);
        });
      } else {
        Dialog.alert({
          message: '添加失败',
        });
      }
    } catch (error) {
      Dialog.alert({
        message: error.message,
      });
    }
  }

  onStartTimeConfirm(value: any) {
    this.form.StartDate = moment(value).format('YYYY-MM-DD');
    this.showStartTimePicker = false;
    this.autoComputeDays(this.form.StartDate, this.form.EndDate);
  }
  onEndTimeConfirm(value: any) {
    this.form.EndDate = moment(value).format('YYYY-MM-DD');
    this.showEndTimePicker = false;
    this.autoComputeDays(this.form.StartDate, this.form.EndDate);
  }
  //自动计算天数
  autoComputeDays(startDate: any, endDate: any) {
    //判断开始时间是否大于结束时间
    if (new Date(startDate) >= new Date(endDate)) {
      this.form.StartDate = '';
      this.form.EndDate = '';
      this.form.Days = 0;
      Notify({
        message: '开始日期不能大于或等于截止日期',
        type: 'warning',
        duration: 5000,
      });
    }

    if (startDate && endDate && new Date(endDate) > new Date(startDate)) {
      let day1: any = new Date(startDate);
      let day2: any = new Date(endDate);
      let result = day2 - day1;
      this.form.Days = Math.abs(result) / 1000 / 60 / 60 / 24 + 1;
    }
  }

  onClickLeft() {
    this.$router.go(-1);
  }
}
